import React, { useEffect, useState } from 'react';
import { RouteChildrenProps } from 'react-router-dom';
import { SubCategory, Topic } from 'types';
import api from 'utils/api-services';
import { LeftNavLayout } from '..';
import { MainContentPageLayout } from './MainContentPageLayout';

interface RouteParams {
  deeplink: string;
}

const DeeplinkPageContainer: React.FunctionComponent<RouteChildrenProps<RouteParams>> = (props) => {
  const { match } = props;
  const deeplink = match!.params.deeplink;
  const [subcategories, setSubcategories] = useState<SubCategory[]>([]);
  const [currentTopic, setCurrentTopic] = useState<Topic>();
  const [catId, setCatId] = useState(1);
  const [catName, setCatName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    api.getTopicByAlias(deeplink).then((item) => {
      setCurrentTopic(item.topic);
      setCatId(item.topic.categoryId);
      setCatName(item.categoryName);
      api.getFaqCategory(item.topic.categoryId).then((cat) => {
        setSubcategories(
          cat.map((subcategory) => ({
            ...subcategory,
            categoryId: item.topic.categoryId,
          })) as SubCategory[]
        );
        setIsLoading(false);
      });
    });
  }, []);

  return (
    <LeftNavLayout activeCategoryId={catId}>
      <MainContentPageLayout
        currentCategoryName={catName}
        currentSubCategories={subcategories}
        currentTopic={currentTopic}
        isLoading={isLoading}
      />
    </LeftNavLayout>
  );
};

export default DeeplinkPageContainer;
